import { render, staticRenderFns } from "./SingleSilder.vue?vue&type=template&id=a6bcfdb2&scoped=true"
import script from "./SingleSilder.vue?vue&type=script&lang=js"
export * from "./SingleSilder.vue?vue&type=script&lang=js"
import style0 from "./SingleSilder.vue?vue&type=style&index=0&id=a6bcfdb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bcfdb2",
  null
  
)

export default component.exports